/* Find my size: "you usually wear X -> choose Y" (size up one, compression fit) */
(function () {
  if (window.__clvFit) return; window.__clvFit = true;
  var USUAL = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];
  var US = { XS: '0–2', S: '4–6', M: '8–10', L: '12–14', XL: '16–18', XXL: '20–22', '3XL': '24–26' };
  var PICK = { XS: ['S/M', 'S', 'M'], S: ['S/M', 'M', 'S'], M: ['M/L', 'L', 'M'], L: ['XL', 'L/XL', 'L'], XL: ['XXL', '2XL', 'XL'], XXL: ['3XL', 'XXXL', 'XXL'], '3XL': ['3XL', 'XXXL'] };
  var css = '.clv-fit{display:flex;flex-direction:column;gap:14px;text-align:left;color:var(--ink)}' +
    '.clv-fit__eyebrow{font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:var(--ink-soft);font-weight:700;margin:0}' +
    '.clv-fit__q{font-size:20px;line-height:1.25;font-weight:800;margin:0}' +
    '.clv-fit__grid{display:grid;grid-template-columns:repeat(7,1fr);gap:6px}' +
    '.clv-fit__btn{height:50px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:1px;line-height:1.1;border:1px solid var(--blue-line);border-radius:8px;background:#fff;color:var(--ink);font-weight:700;font-size:13px;cursor:pointer}' +
    '.clv-fit .clv-fit__btn{background:#fff!important;color:var(--ink)!important;box-shadow:none!important;border:1px solid var(--blue-line)!important;border-radius:8px!important;padding:0 2px!important;min-width:0;text-transform:none;letter-spacing:0}' +
    '.clv-fit__btn small{font-size:10px;font-weight:500;opacity:.7;white-space:nowrap}.clv-fit__us{color:var(--ink-soft);font-size:12px}' +
    '.clv-fit .clv-fit__btn[aria-pressed="true"]{background:var(--ink)!important;color:#fff!important;border-color:var(--ink)!important}' +
    '.clv-fit .clv-fit__go{background:var(--cta)!important;color:#fff!important}' +
    '.clv-fit__res{background:var(--blue-soft);border:1px solid var(--blue-line);border-radius:12px;padding:16px;display:flex;flex-direction:column;gap:8px}' +
    '.clv-fit__res[hidden]{display:none}' +
    '.clv-fit__rec{font-size:17px;margin:0}.clv-fit__rec b{font-size:22px}' +
    '.clv-fit__why,.clv-fit__unsure{font-size:13px;color:var(--ink-2);margin:0;line-height:1.5}' +
    '.clv-fit__go{margin-top:4px;height:48px;border:0;border-radius:999px;background:var(--cta);color:#fff;font-weight:800;font-size:14px;letter-spacing:.04em;cursor:pointer}' +
    '.clv-fit__tbl{width:100%;border-collapse:collapse;font-size:13px}' +
    '.clv-fit__tbl th,.clv-fit__tbl td{padding:8px 10px;border-bottom:1px solid var(--line);text-align:left}' +
    '.clv-fit__tbl th{font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:var(--ink-soft)}' +
    '.clv-fit__tbl td:last-child{font-weight:800}' +
    '.clv-fit-modal{position:fixed;inset:0;z-index:9999;background:rgba(43,33,28,.55);display:flex;align-items:flex-end;justify-content:center}' +
    '.clv-fit-modal[hidden]{display:none}' +
    '.clv-fit-modal__box{background:#fff;width:100%;max-width:520px;max-height:92vh;overflow:auto;border-radius:18px 18px 0 0;padding:22px 18px calc(22px + env(safe-area-inset-bottom,0px));position:relative}' +
    '@media (min-width:700px){.clv-fit-modal{align-items:center}.clv-fit-modal__box{border-radius:18px;padding:28px}}' +
    '.clv-fit-modal__x{position:absolute;top:10px;right:10px;width:36px;height:36px;border-radius:50%;border:0;background:var(--soft);font-size:20px;cursor:pointer;color:var(--ink)}' +
    '.clv-fit-tip{margin:8px 0 0;font-size:13px;line-height:1.45;color:var(--ink-2);background:var(--blue-soft);border:1px solid var(--blue-line);border-radius:10px;padding:10px 12px}' +
    '.clv-fit-tip button{background:none;border:0;padding:0;margin-left:4px;font:inherit;font-weight:800;text-decoration:underline;color:var(--ink);cursor:pointer}' +
    '.clv-fit-page{max-width:560px;margin:0 auto 24px}' +
    '@media (max-width:420px){.clv-fit__grid{grid-template-columns:repeat(4,1fr)}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function sizesOnPage() {
    return Array.prototype.map.call(document.querySelectorAll('.clv-size[data-value]'), function (b) { return b.dataset.value; });
  }
  function rec(usual) {
    var have = sizesOnPage(), list = PICK[usual];
    if (!have.length) return list[0];
    for (var i = 0; i < list.length; i++) if (have.indexOf(list[i]) > -1) return list[i];
    return list[0];
  }
  function build(inModal) {
    var onPdp = sizesOnPage().length > 0;
    var el = document.createElement('div'); el.className = 'clv-fit';
    var rows = USUAL.map(function (u) { return '<tr><td>' + u + ' <span class="clv-fit__us">(US ' + US[u] + ')</span></td><td>' + rec(u) + '</td></tr>'; }).join('');
    el.innerHTML = '<p class="clv-fit__eyebrow">Find my size</p>' +
      '<p class="clv-fit__q">What size do you usually wear in leggings or jeans?</p>' +
      '<div class="clv-fit__grid" role="group" aria-label="Your usual size">' + USUAL.map(function (u) { return '<button type="button" class="clv-fit__btn" aria-pressed="false" data-u="' + u + '">' + u + '<small>' + US[u] + '</small></button>'; }).join('') + '</div>' +
      '<div class="clv-fit__res" hidden aria-live="polite"><p class="clv-fit__rec"></p>' +
      '<p class="clv-fit__why">Our shapewear has firm compression, so we size you up one size. You get the snatched look without it feeling too tight.</p>' +
      '<p class="clv-fit__unsure"><b>Not sure?</b> Go for the bigger size – it’s easier to put on and still snatches.</p>' +
      (onPdp ? '<button type="button" class="clv-fit__go"></button>' : '') + '</div>' +
      '<table class="clv-fit__tbl"><thead><tr><th>You usually wear</th><th>Choose</th></tr></thead><tbody>' + rows + '</tbody></table>';
    el.addEventListener('click', function (e) {
      var b = e.target.closest('.clv-fit__btn');
      if (b) {
        el.querySelectorAll('.clv-fit__btn').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var r = rec(b.dataset.u), res = el.querySelector('.clv-fit__res');
        res.hidden = false;
        res.querySelector('.clv-fit__rec').innerHTML = 'You wear ' + b.dataset.u + ' (US ' + US[b.dataset.u] + ') → we recommend <b>' + r + '</b>';
        var go = res.querySelector('.clv-fit__go'); if (go) { go.textContent = 'CHOOSE ' + r; go.dataset.size = r; }
        return;
      }
      var g = e.target.closest('.clv-fit__go');
      if (g) {
        var sb = document.querySelector('.clv-size[data-value="' + g.dataset.size + '"]');
        if (sb) sb.click();
        close();
        var form = sb && sb.closest('.clv-opt'); if (form) form.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    });
    return el;
  }
  var modal = null, lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    if (!modal) {
      modal = document.createElement('div'); modal.className = 'clv-fit-modal'; modal.hidden = true;
      modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', 'Find my size');
      var box = document.createElement('div'); box.className = 'clv-fit-modal__box';
      box.innerHTML = '<button type="button" class="clv-fit-modal__x" aria-label="Close">×</button>';
      box.appendChild(build(true)); modal.appendChild(box); document.body.appendChild(modal);
      modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('.clv-fit-modal__x')) close(); });
    }
    modal.hidden = false; document.documentElement.style.overflow = 'hidden';
    var f = modal.querySelector('.clv-fit__btn'); if (f) f.focus();
  }
  function close() {
    if (!modal) return; modal.hidden = true; document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  function init() {
    var onPdp = sizesOnPage().length > 0;
    if (onPdp) {
      var opt = document.querySelector('.clv-size').closest('.clv-opt');
      var note = opt && opt.querySelector('.clv-note');
      var ex = rec('M');
      var tip = document.createElement('p'); tip.className = 'clv-fit-tip';
      tip.innerHTML = '💡 <b>Wear an M? Choose ' + ex + '.</b> Size up one from your usual bottom size – it runs small due to the compression.<button type="button" data-clv-fit-open>Find my size</button>';
      if (note) note.replaceWith(tip); else if (opt) opt.appendChild(tip);
    }
    if (document.body.classList.contains('template-page') && /size-guide/.test(location.pathname)) {
      var main = document.querySelector('main') || document.body;
      var table = main.querySelector('table');
      var host = table ? (table.closest('.rte, .clv-page__body, article, section') || table.parentNode) : null;
      var wrap = document.createElement('div'); wrap.className = 'clv-fit-page'; wrap.appendChild(build(false));
      if (host) { host.innerHTML = ''; host.appendChild(wrap); }
    }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a, [data-clv-fit-open]');
    if (!a) return;
    var txt = (a.textContent || '').trim().toLowerCase();
    var hit = a.hasAttribute('data-clv-fit-open') ||
      (sizesOnPage().length > 0 && (/size-guide/.test(a.getAttribute('href') || '') || txt === 'find my fit' || txt === 'size guide'));
    if (hit) { e.preventDefault(); open(); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
